import { getLocale } from '../utils/pathHelper';

document.addEventListener('turbolinks:load', () => {
  const $ = (window as any).jQuery;
  const locale = getLocale({ underscore: true });

  const PENDING_TIME = 1500;
  const ITEM_CSS = 'list-group-item small p-2';

  const $container = $('.js-keyword-search');
  const $results   = $('.js-keyword-search-results');
  const $input     = $container.find('input');

  if (!$container.length || !$container.length) { return; }

  function searchByKeyword(keyword: string): void {
    fetch(`/snow/api/v1/searches/keyword/${keyword}`)
      .then(data => data.json())
      .then((json) => {
        resetResult();
        toggleResult({ show: true });
        const { resorts, searches } = json;
        if (!resorts.length && !searches.length) { renderNotFound(); }
        if (searches.length) {
          searches.map(search => renderSearchItem(search));
        }
        if (resorts.length) {
          resorts.map(resort => renderItem(resort));
        }
      })
      .catch((error) => {
        global.console.error(error);
      })
  }

  function renderSearchItem(search: { type: string, title: string, entries: Array<{slug: string, title: string}>}) {
    const { type, title, entries } = search;
    if (!entries.length) { return; }

    $results.append(`
      <div class="${ITEM_CSS} font-weight-bold border-bottom">
        <i class="fas fa-fw fa-search"></i>
        ${title}
      </div>
    `);
    entries.forEach((entry) => {
      const pathname = `/snow/searches/${type}/${entry.slug}`;
      $results.append(`
        <a class="${ITEM_CSS} list-group-item-action pl-4" href="${pathname}">
          ${entry.title}
        </a>
      `);
    });
  }

  function renderItem(resort: any): void {
    const title = resort[`name_${locale}`];
    if (!title) { return; }
    $results.append(`
      <a class="${ITEM_CSS} list-group-item-action" href="/snow/resorts/${resort.resort_code}">
        <i class="fas fa-fw fa-map-marker text-secondary"></i>
        ${title}
      </a>
    `);
  }

  function toggleLoading({ show }: { show?: boolean } = {}): void {
    toggleResult({ show });
    if (show) {
      $results.html(`
        <div class="text-center p-2">
          <i class="fas fa-spinner fa-spin fa-fw text-primary"></i>
        </div>
      `);
    } else {
      $results.html(null);
    }
  }

  function renderNotFound(): void {
    $results.append(`
      <div class="list-group-item small">Not found</div>
    `);
  }

  function resetResult(): void {
    $results.html(null);
  }

  function toggleResult({ show }: { show?: boolean } = {}): void {
    if (show) {
      $results.show();
    } else {
      $results.hide();
    }
  }


  const win = window as any;
  let timer = null;
  let blurTimer = null;

  $input.on('keyup compositionend', (e: any) => {
    // compositionend: 変換確定
    win.clearTimeout(timer);
    const { value } = e.currentTarget;
    if (!value) { return; }

    toggleLoading({ show: true });
    timer = win.setTimeout(() => {
      searchByKeyword(value);
    }, PENDING_TIME);
  });

  $input.on('blur', () => {
    win.clearTimeout(blurTimer);
    blurTimer = win.setTimeout(() => {
      toggleResult({ show: false });
    }, 500);
  });

});
